module.exports = __webpack_public_path__ + "static/img/b3ad035570723ce6c41ecb8a09334f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MODE2-on.png
// module id = ohve
// module chunks = 1